
<div>

  <template
      v-if="showDropdownSelect">

    <a-select
        v-if="objectModelProperty.selection_type === PickListSelectionType.SingleSelect"
        :id="`entry_field_${propertyClientId}`"
        :options="dropdownOptions"
        :value="value && value[0]"
        :disabled="disabled"
        @input="toggleOption"
        bind-by-object
        force-nullify-if-null
        v-tooltip.wrap="tooltipIfDisabled"
        :class="commonEntriesPropertiesCssClasses"
    ></a-select>
    <template v-else>
      <a-select
          :id="$attrs.id"
          :options="dropdownOptions"
          :selectedOptionIds="value"
          bind-by-object
          :multiselect="true"
          compress
          @input="toggleMultiSelect"
         ></a-select>

      <template v-for="val in selectedValues">
        <pill
            @onRemove="toggleOption(val)"
            :value="val.label_title"
        ></pill>
      </template>
    </template>
  </template>

  <row v-else v-for="option of pickListOptions" :key="`option-${option.client_id}`">
    <column>
      <input
          :disabled="disabled"
          :type="inputType"
          :id="`option-${option.client_id}`"
          :checked="optionChecked(option)"
          v-tooltip.wrap.span="tooltipIfDisabled"
          :class="commonEntriesPropertiesCssClasses"
          @click="toggleOption(option)"
      />
      <label :for="`option-${option.client_id}`" class="d-inline">{{ option.labelTitleDisplay }}</label>
    </column>
  </row>
</div>
